import { stageRegionAuthConfig } from "../config/auth.config";
import { devSettings } from "../config/developer";
import { authConfig } from "../fixtures/authConfig";
import type { AuthSettings } from "../store/auth";
import { APPENV } from "../utils/app.environment";

const mockServerAuthSettings: AuthSettings = authConfig;

export const getWebsiteSettingsFromConfig = (): AuthSettings => {
    if (APPENV.mock_server) {
        return mockServerAuthSettings;
    }

    return getAuthSettings();
};

export const getAuthSettings = (): AuthSettings => {
    const host: string = window.location.hostname;
    const authSettings = stageRegionAuthConfig.get(host) ?? devSettings;
    return authSettings;
};
